import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/user-actions/UserActionsAction";
import { CustomSelect, redirectToPages, UserType, UserTypeOptions } from "../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { PersonnelUsersPage } from "./personnel-users/PersonnelUsersPage";
import { TeacherUsersPage } from "./teacher-users/TeacherUsersPage";
import { StudentUsersPage } from "./student-users/StudentUsersPage";
import { ParentUsersPage } from "./parent-users/ParentUsersPage";

export function UserActionsPage() {
  const [userType, setUserType] = useState();

  // Getting curret state of UserActions from store (Redux)
  const dispatch = useDispatch();
  const { actionLoading, isSuccess, type } = useSelector(
    (state) => ({
      actionLoading: state.userActions.actionLoading,
      isSuccess: state.userActions.isSuccess,
      type: state.userActions.type
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getUserGroups());
  }, [dispatch]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const userTypeOptions = UserTypeOptions.filter(option => option.value !== UserType.System);
  
  return (
    <>
      <Card>
        {actionLoading && <ModalProgressBar />}
        <CardHeader title="Kullanıcı İşlemleri" />
        <CardBody>
          <div className="form-group row">
            <div className="col-3 mt-3">
              Kullanıcı Türü
            </div>
            <div className="col-4">
              <CustomSelect
                options={userTypeOptions}
                onChange={option => setUserType(option.value)}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      {
        userType === UserType.Personnel &&
        <PersonnelUsersPage />
      }
      {
        userType === UserType.Teacher &&
        <TeacherUsersPage />
      }
      {
        userType === UserType.Student &&
        <StudentUsersPage />
      }
      {
        userType === UserType.Parent &&
        <ParentUsersPage />
      }
    </>    
  );
}